<template>
	<div>
		<el-dialog title="税盘信息" :visible.sync="isaddkpj" width="480px" :close-on-click-modal="false" v-dialogDrag
			:close-on-press-escape="false">
			<!-- <minhead :headtitle="kpjtitle" :isdiag="true" :noheadtou="true"></minhead> -->
			<div style="width: 400px">
				<taxform :Formlist="formlist" @inputinput="inputinput" :labelwidth="'110px'" ref="taxform"
					:formdata="kpjform" @getdata="getdata"></taxform>
				<!-- 	<el-button plain type="primary" style="justify-content: center;margin-left: 45%;margin-bottom: 20px; padding:10px 25px" @click="savekpj">保存</el-button> -->
				<div class="addstyle" style="justify-content: center;margin-left: 45%;" @click="savekpj">保存</div>
			</div>
		</el-dialog>

		<div style="display: flex;justify-content: center;">
			<el-dialog :visible.sync="xqdiag" width="800px" :close-on-click-modal="false" append-to-body v-dialogDrag
				title="详情">
				<div class="Verticalcenter">
					<div style="margin-bottom: 10px;" class="Centerupdown">
						<div class="pzstyle">票种选择</div>
						<el-select v-model="faplxdm" placeholder="请选择" @change="selectFplxdmChange">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-button style="margin-left: 20px;" type="primary"
							@click="selectChange(faplxdm)">在线获取</el-button>
					</div>
					<taxform :Formlist="oneformlist" labelwidth="140px" :formdata="formdata" ref="taxformDetail"
						style="min-width: 400px; padding-left: 110px;" :column="1"></taxform>
					<div class="Centerupdown" style="min-width: 400px; padding-left: 190px;">
						<div class="pzstyle">单张开票限额:</div>
						<div style="font-size :18px;color: #00BFFF;" v-if="oneKpxe != '' && oneKpxe != undefined">
							￥{{ oneKpxe | getArea }} 元</div>
					</div>
					<div class="buttomanniu" style="justify-content: center;margin-top: 10px;">
						<el-button @click="xqdiag = false" style="margin-right: 30px;margin-left: 30px;">返回</el-button>
					</div>
				</div>
			</el-dialog>
		</div>

		<el-dialog title="基本信息" :visible.sync="jbxxdiag" width="1005px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :headtitle="jbxxtitle" :isdiag="true"></minhead> -->
			<div class="Centerhorizontally" style="margin-bottom: 25px;">
				<div v-for="(item, index) in jbheadlist" :key="index" @click="changeindex(index)" class="choosediv">
					<div :style="chooseheadindex == index ? 'color: #0065B1;' : 'opacity: 0.34'">{{ item.title }}</div>
					<div :style="chooseheadindex == index ? 'background: #0065B1;' : 'background: white'"
						class="lineall"></div>
				</div>
			</div>
			<div>
				<div style="width: 100%;max-height: 400px; overflow-y: auto;" class="horizontally"
					v-if="chooseheadindex == 0">
					<el-form class="demo-ruleForm" :disabled="!openaddseller" ref="jibenform" label-width="110px"
						:rules="jbrules" :model="jibenform">
						<div class="Centerupdown">
							<el-form-item label="企业编号:" :label-width="formLabelWidth">
								<el-input v-model="jibenform.code" style="width:215px" maxlength="50"
									disabled></el-input>
							</el-form-item>
							<el-form-item label="纳税人识别号:" prop="taxNumber" :label-width="formLabelWidth">
								<el-input v-model="jibenform.taxNumber" maxlength="25" :disabled="isOpenType != 0"
									style="width:215px" @input="invalidSerchForm('taxNumber')"></el-input>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="公司代码:" prop="qiybh" :label-width="formLabelWidth">
								<el-input v-model="jibenform.qiybh" maxlength="30" :disabled="isOpenType != 0"
									style="width:215px" @input="invalidSerchForm('qiybh')"></el-input>
							</el-form-item>
							<el-form-item label="纳税人名称:" prop="name" :label-width="formLabelWidth">
								<el-input v-model="jibenform.name" maxlength="100" style="width:215px"></el-input>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="开户行及账号:" prop="bankAccount" :label-width="formLabelWidth">
								<el-input v-model="jibenform.bankAccount" maxlength="200"
									style="width:215px"></el-input>
							</el-form-item>
							<el-form-item label="地址、电话:" prop="addressPhone" maxlength="200"
								:label-width="formLabelWidth">
								<el-input v-model="jibenform.addressPhone" style="width:215px"></el-input>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="纳税人类型:" prop="type" :label-width="formLabelWidth">
								<el-select v-model="jibenform.type" style="width: 215px;">
									<el-option label="小规模纳税人" value="1"></el-option>
									<el-option label="一般纳税人" value="0"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="联系人:" prop="contact" :label-width="formLabelWidth">
								<el-input v-model="jibenform.contact" maxlength="25" style="width:215px"></el-input>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="手机号:" prop="phoneNumber" :label-width="formLabelWidth">
								<el-input v-model="jibenform.phoneNumber" maxlength="25" style="width:215px"></el-input>
							</el-form-item>
							<el-form-item label="邮箱:" prop="email" :label-width="formLabelWidth">
								<el-input v-model="jibenform.email" maxlength="50" style="width:215px"></el-input>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="授权密钥:" prop="authKey" :label-width="formLabelWidth">
								<el-input v-model="jibenform.authKey" maxlength="50" style="width:215px"></el-input>
							</el-form-item>
							<el-form-item label="状态:" prop="state" class="moreserch" :label-width="formLabelWidth">
								<el-select v-model="jibenform.state" style="width: 215px;">
									<el-option label="正常" value="0"></el-option>
									<el-option label="停用" value="1"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="字段超长截取:" prop="cczdjq" :label-width="formLabelWidth">
								<el-select v-model="jibenform.cczdjq" style="width: 215px;">
									<el-option label="启用" value="0"></el-option>
									<el-option label="关闭" value="1"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="普票抬头:" prop="qixbMhkg" :label-width="formLabelWidth">
								<el-select v-model="jibenform.qixbMhkg" style="width: 215px;">
									<el-option label="关" value="0"></el-option>
									<el-option label="开" value="1"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="专票抬头:" prop="qixbZlkg" :label-width="formLabelWidth">
								<el-select v-model="jibenform.qixbZlkg" style="width: 215px;" disabled>
									<el-option label="关" value="0"></el-option>
									<el-option label="开" value="1"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="备注:" prop="position" :label-width="formLabelWidth">
								<el-input v-model="jibenform.position" maxlength="20" style="width:215px"></el-input>
							</el-form-item>
							<el-form-item label="省份:" v-if="false">
								<el-select v-model="jibenform.shengf" style="width: 215px;">
									<el-option v-for="item in selectShengf" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</el-form>
				</div>
				<div style="width: 100%;" class="horizontally" v-if="chooseheadindex == 1">
					<div>
						<div style="margin-bottom: 25px;display: flex;">
							<div v-for="(item, index) in mainlist" :key="index" @click="changemainindex(index)"
								class="choosedivmain">
								<div :style="choosemainindex == index ? '' : 'opacity: 0.34'">{{ item.title }}</div>
								<div :style="choosemainindex == index ? 'background: #0080FF' : 'background: white'"
									class="lineall"></div>
							</div>
						</div>
						<div v-if="choosemainindex == 3">
							<el-form class="demo-ruleForm" :disabled="!openaddseller" label-width="100px"
								:model="xxiangform">
								<div class="Centerupdown">
									<el-form-item label="虚拟设备号:"><el-input v-model="xxiangform.xunsbh"
											style="width:215px"></el-input></el-form-item>

									<el-form-item label="税控服务器设备号:" :label-width="formLabelWidth">
										<el-input v-model="xxiangform.shuiksbh" style="width:215px"></el-input>
									</el-form-item>
								</div>
								<div class="Centerupdown">
									<el-form-item label="虚拟设备口令:"><el-input v-model="xxiangform.xunsbkn"
											style="width:215px"></el-input></el-form-item>
									<el-form-item label="代理服务器设备号:" :label-width="formLabelWidth">
										<el-input v-model="xxiangform.dailsbh" style="width:215px"></el-input>
									</el-form-item>
								</div>
								<div class="forkuozhan">扩展信息</div>
								<div class="Centerupdown">
									<el-form-item label="开票标志:">
										<el-select v-model="xxiangform.kaipbz" style="width: 215px;">
											<el-option label="有效" value="1"></el-option>
											<el-option label="停用" value="0"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item :label-width="formLabelWidth" label="距离开票截止日期:">
										<el-input v-model="xxiangform.as5" style="width:215px"></el-input>
									</el-form-item>
								</div>
								<div class="Centerupdown">
									<el-form-item label="登记序号:"><el-input v-model="xxiangform.dengjxh"
											style="width:215px"></el-input></el-form-item>

									<el-form-item label="小规模开具专票标识:" :label-width="formLabelWidth">
										<el-select v-model="xxiangform.xiaogmkjzpbs" style="width: 215px;">
											<el-option label="有效" value="1"></el-option>
											<el-option label="停用" value="0"></el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="Centerupdown">
									<el-form-item label="特定企业:">
										<el-select v-model="xxiangform.tedqy" style="width: 215px;">
											<el-option label="是" value="01"></el-option>
											<el-option label="不是" value="00"></el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="进项授权标识:" :label-width="formLabelWidth">
										<el-select v-model="xxiangform.jinxsqbz" style="width: 215px;">
											<el-option label="有效" value="1"></el-option>
											<el-option label="停用" value="0"></el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="Centerupdown">
									<el-form-item label="省份:">
										<el-select v-model="xxiangform.shengf" style="width: 215px;">
											<el-option v-for="item in selectShengf" :key="item.value"
												:label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="请求方式:" prop="qingqfs">
										<el-select v-model="xxiangform.qingqfs" style="width: 120px;">
											<el-option label="税控服务器" value="1"></el-option>
											<el-option label="共享柜" value="2"></el-option>
											<el-option label="开票盘" value="3"></el-option>
											<el-option label="网关" value="4"></el-option>
										</el-select>
									</el-form-item>
								</div>
							</el-form>
						</div>
						<div v-if="choosemainindex == 0" style="width: 700px">
							<div>
								<el-button plain type="primary" style="margin-bottom: 30px;" v-if="1 != 1"
									@click="addthis">
									新增
									<!--
                  <i class="el-icon-circle-plus-outline el-icon--right"></i> -->
								</el-button>
							</div>
							<el-radio-group v-model="radiochange">
								<div class="demo-ruleForm" style="width: 100%">
									<el-button type="danger" @click="addkpj"
										:disabled="isOpenType == 1">新增税盘</el-button>
									<Taxtable style="margin-bottom: 10px" :headData="HeadData" :tableData="kpjdata"
										:disabled="!openaddseller" :tableref="'mainComboTable'">
										<template v-slot:queskpj="scope">
											<p v-if="scope.taxval.queskpj == '1'"><img
													src="../../../assets/img/mr.svg" /></p>
											<p v-if="scope.taxval.queskpj == '0'"></p>
										</template>
										<template v-slot:equipmentType="scope">
											<p v-if="scope.taxval.equipmentType == '0'">金税盘</p>
											<p v-if="scope.taxval.equipmentType == '2'">税控盘</p>
											<p v-if="scope.taxval.equipmentType == '1'">税务UKEY</p>
										</template>
										<template v-slot:management="scope">
											<p v-if="scope.taxval.management == '1'">托管</p>
											<p v-if="scope.taxval.management == '0'">自持</p>
										</template>
										<template v-slot:cz="scope">
											<el-button type="text" size="small" :disabled="isOpenType == 1"
												@click="deletekpj(scope.taxval)">删除</el-button>
											<el-button type="text" size="small" :disabled="isOpenType == 1"
												@click="updatekpj(scope.taxval)">编辑</el-button>
											<el-button type="text" size="small" @click="kpjdetails(scope.taxval)"
												v-if="scope.taxval.hasOwnProperty('allowFplx') && scope.taxval.allowFplx != ''">
												详情
											</el-button>
										</template>
									</Taxtable>
									<el-table :data="kpjdata" ref="multipleTable" border style="width: 100%"
										v-if="false">
										<el-table-column prop="queskpj" label="默认" align="center" width="50">
											<template slot-scope="scope">
												<p v-if="scope.row.queskpj == '1'"><img
														src="../../../assets/img/mr.svg" /></p>
												<p v-if="scope.row.queskpj == '0'"></p>
											</template>
										</el-table-column>
										<el-table-column prop="equipmentType" label="设备类型" align="center">
											<template slot-scope="scope">
												<p v-if="scope.row.equipmentType == '0'">金税盘</p>
												<p v-if="scope.row.equipmentType == '2'">税控盘</p>
												<p v-if="scope.row.equipmentType == '1'">税务UKEY</p>
											</template>
										</el-table-column>
										<el-table-column prop="kaipjbh" label="设备编号" align="center"></el-table-column>
										<el-table-column prop="kaipjmc" label="设备名称" align="center"></el-table-column>
										<el-table-column prop="mainNo" label="主/分盘号" align="center"></el-table-column>
										<el-table-column prop="management" label="管理方式" align="center">
											<template slot-scope="scope">
												<p v-if="scope.row.management == '1'">托管</p>
												<p v-if="scope.row.management == '0'">自持</p>
											</template>
										</el-table-column>
										<el-table-column prop="kaipr" label="默认开票人" align="center"></el-table-column>
										<el-table-column prop="fuhr" label="默认复核人" align="center"></el-table-column>
										<el-table-column prop="shoukr" label="默认收款人" align="center"></el-table-column>
										<el-table-column fixed="right" label="操作" width="100" align="center">
											<template slot-scope="scope">
												<el-button type="text" size="small" :disabled="!openaddseller"
													@click="deletekpj(scope.row)">删除</el-button>
												<el-button type="text" size="small" :disabled="!openaddseller"
													@click="updatekpj(scope.row)">编辑</el-button>
											</template>
										</el-table-column>
									</el-table>
								</div>
							</el-radio-group>
						</div>
					</div>
				</div>
				<div style="width: 100%;" class="horizontally" v-if="chooseheadindex == 2">
					<div>
						<div style="margin-bottom: 25px;display: flex;">
							<div v-for="(item, index) in kplist" :key="index" @click="changekpindex(index)"
								class="choosedivmain">
								<div :style="choosekpindex == index ? '' : 'opacity: 0.34'">{{ item.title }}</div>
								<div :style="choosekpindex == index ? 'background: #0080FF' : 'background: white'"
									class="lineall"></div>
							</div>
						</div>
						<div v-if="choosekpindex == 0">
							<el-form class="demo-ruleForm" :disabled="!openaddseller" ref="kaipform0"
								label-width="100px" :rules="kaiprules" :model="kaipiaoform0">
								<div class="kuang">
									<div class="forkuozhan">手工拆分设置</div>
									<div class="Centerupdown ">
										<el-form-item label="含税标识:" prop="hansfs">
											<el-select v-model="kaipiaoform0.hansfs" style="width: 215px;" disabled>
												<el-option label="含税" value="1"></el-option>
												<el-option label="不含税" value="0"></el-option>
											</el-select>
										</el-form-item>
									</div>
									<div class="Centerupdown ">
										<el-form-item label="开票版本:" prop="zuidkpje">
											<el-select v-model="kaipiaoform0.zuidkpje" style="width: 215PX;">
												<el-option v-for="item in zuidkpjes" :key="item.value"
													:label="item.label" :value="item.value"></el-option>
											</el-select>
										</el-form-item>
										<el-form-item :label-width="formLabelWidth" label="最大开票明细数量:" prop="zuidkpmxsl">
											<el-input v-model="kaipiaoform0.zuidkpmxsl" style="width:215px"></el-input>
										</el-form-item>
									</div>
								</div>
								<div class="kuang">
									<div class="forkuozhan">计算方式设置</div>
									<div class="Centerupdown ">
										<el-form-item label="单价精度:" prop="danjjd"><el-input
												v-model="kaipiaoform0.danjjd"
												style="width:110px"></el-input></el-form-item>
										<el-form-item label-width="100px" label="数量精度:" prop="shuljd">
											<el-input v-model="kaipiaoform0.shuljd" style="width:110px"></el-input>
										</el-form-item>
										<el-form-item label="最大拆分方式" :label-width="formLabelWidth" prop="zdjecf">
											<el-radio-group v-model="kaipiaoform0.zdjecf">
												<el-radio label="0">按数量</el-radio>
												<el-radio label="1">按单价</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
								</div>
								<div class="kuang">
									<div class="forkuozhan between-line"><span>导入配置</span></div>
									<div class="Centerupdown ">
										<el-form-item label="导入覆盖方式" style="width: 300px;" label-width="110px"
											prop="daorfgfs">
											<el-radio-group v-model="kaipiaoform0.daorfgfs">
												<el-radio label="1">覆盖</el-radio>
												<el-radio label="2">拒绝</el-radio>
												<el-radio label="3">追加</el-radio>
											</el-radio-group>
										</el-form-item>
										<el-form-item label="导入计算方式" label-width="110px" prop="daorjsgz">
											<el-radio-group v-model="kaipiaoform0.daorjsgz">
												<el-radio label="1">数量*单价=金额</el-radio>
												<el-radio label="2">金额/数量=单价</el-radio>
												<el-radio label="3">金额/单价=数量</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
									<div class="Centerupdown ">
										<el-form-item label="客户主数据更新" label-width="110px" style="width: 300px;"
											prop="kehzsjgx">
											<el-radio-group v-model="kaipiaoform0.kehzsjgx">
												<el-radio label="1">更新</el-radio>
												<el-radio label="0">不更新</el-radio>
											</el-radio-group>
										</el-form-item>
										<el-form-item label="客户主数据关联" label-width="110px" prop="kehzsjgl">
											<el-radio-group v-model="kaipiaoform0.kehzsjgl">
												<el-radio label="0">不关联</el-radio>
												<el-radio label="1">客户名称关联</el-radio>
												<el-radio label="2">客户编码关联</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
									<div class="Centerupdown ">
										<el-form-item label="商品主数据关联" label-width="110px" prop="spzsjgl">
											<el-radio-group v-model="kaipiaoform0.spzsjgl">
												<el-radio label="0">不关联</el-radio>
												<el-radio label="1">商品名称关联</el-radio>
												<el-radio label="2">商品编码关联</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
								</div>
							</el-form>
						</div>
						<div v-if="choosekpindex == 1">
							<el-form class="demo-ruleForm" :disabled="!openaddseller" ref="kaipform1"
								label-width="100px" :rules="kaiprules" :model="kaipiaoform1">
								<div class="kuang">
									<div class="forkuozhan">手工拆分设置</div>
									<div class="Centerupdown ">
										<el-form-item label="含税标识:" prop="hansfs">
											<el-select v-model="kaipiaoform1.hansfs" style="width: 215px;" disabled>
												<el-option label="含税" value="1"></el-option>
												<el-option label="不含税" value="0"></el-option>
											</el-select>
										</el-form-item>
									</div>
									<div class="Centerupdown ">
										<el-form-item label="开票版本:" prop="zuidkpje">
											<el-select v-model="kaipiaoform1.zuidkpje" style="width: 215PX;">
												<el-option v-for="item in zuidkpjes" :key="item.value"
													:label="item.label" :value="item.value"></el-option>
											</el-select>
										</el-form-item>
										<el-form-item :label-width="formLabelWidth" label="最大开票明细数量:" prop="zuidkpmxsl">
											<el-input v-model="kaipiaoform1.zuidkpmxsl" style="width:215px"></el-input>
										</el-form-item>
									</div>
								</div>
								<div class="kuang">
									<div class="forkuozhan">计算方式设置</div>
									<div class="Centerupdown ">
										<el-form-item label="单价精度:" prop="danjjd"><el-input
												v-model="kaipiaoform1.danjjd"
												style="width:110px"></el-input></el-form-item>
										<el-form-item label-width="100px" label="数量精度:" prop="shuljd">
											<el-input v-model="kaipiaoform1.shuljd" style="width:110px"></el-input>
										</el-form-item>
										<el-form-item label="最大拆分方式" :label-width="formLabelWidth" prop="zdjecf">
											<el-radio-group v-model="kaipiaoform1.zdjecf">
												<el-radio label="0">按数量</el-radio>
												<el-radio label="1">按单价</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
								</div>
								<div class="kuang">
									<div class="forkuozhan between-line"><span>导入配置</span></div>
									<div class="Centerupdown ">
										<el-form-item label="导入覆盖方式" style="width: 300px;" label-width="110px"
											prop="daorfgfs">
											<el-radio-group v-model="kaipiaoform1.daorfgfs">
												<el-radio label="1">覆盖</el-radio>
												<el-radio label="2">拒绝</el-radio>
												<el-radio label="3">追加</el-radio>
											</el-radio-group>
										</el-form-item>
										<el-form-item label="导入计算方式" label-width="110px" prop="daorjsgz">
											<el-radio-group v-model="kaipiaoform1.daorjsgz">
												<el-radio label="1">数量*单价=金额</el-radio>
												<el-radio label="2">金额/数量=单价</el-radio>
												<el-radio label="3">金额/单价=数量</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
									<div class="Centerupdown ">
										<el-form-item label="客户主数据更新" label-width="110px" style="width: 300px;"
											prop="kehzsjgx">
											<el-radio-group v-model="kaipiaoform1.kehzsjgx">
												<el-radio label="1">更新</el-radio>
												<el-radio label="0">不更新</el-radio>
											</el-radio-group>
										</el-form-item>
										<el-form-item label="客户主数据关联" label-width="110px" prop="kehzsjgl">
											<el-radio-group v-model="kaipiaoform1.kehzsjgl">
												<el-radio label="0">不关联</el-radio>
												<el-radio label="1">客户名称关联</el-radio>
												<el-radio label="2">客户编码关联</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
									<div class="Centerupdown ">
										<el-form-item label="商品主数据关联" label-width="110px" prop="spzsjgl">
											<el-radio-group v-model="kaipiaoform1.spzsjgl">
												<el-radio label="0">不关联</el-radio>
												<el-radio label="1">商品名称关联</el-radio>
												<el-radio label="2">商品编码关联</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
								</div>
							</el-form>
						</div>
						<div v-if="choosekpindex == 2">
							<el-form class="demo-ruleForm" :disabled="!openaddseller" ref="kaipform2"
								label-width="100px" :rules="kaiprules" :model="kaipiaoform2">
								<div class="kuang">
									<div class="forkuozhan">手工拆分设置</div>
									<div class="Centerupdown ">
										<el-form-item label="含税标识:" prop="hansfs">
											<el-select v-model="kaipiaoform2.hansfs" style="width: 215px;" disabled>
												<el-option label="含税" value="1"></el-option>
												<el-option label="不含税" value="0"></el-option>
											</el-select>
										</el-form-item>
									</div>
									<div class="Centerupdown ">
										<el-form-item label="开票版本:" prop="zuidkpje">
											<el-select v-model="kaipiaoform2.zuidkpje" style="width: 215PX;">
												<el-option v-for="item in zuidkpjes" :key="item.value"
													:label="item.label" :value="item.value"></el-option>
											</el-select>
										</el-form-item>
										<el-form-item :label-width="formLabelWidth" label="最大开票明细数量:" prop="zuidkpmxsl">
											<el-input v-model="kaipiaoform2.zuidkpmxsl" style="width:215px"></el-input>
										</el-form-item>
									</div>
								</div>
								<div class="kuang">
									<div class="forkuozhan">计算方式设置</div>
									<div class="Centerupdown ">
										<el-form-item label="单价精度:" prop="danjjd"><el-input
												v-model="kaipiaoform2.danjjd"
												style="width:110px"></el-input></el-form-item>
										<el-form-item label-width="100px" label="数量精度:" prop="shuljd">
											<el-input v-model="kaipiaoform2.shuljd" style="width:110px"></el-input>
										</el-form-item>
										<el-form-item label="最大拆分方式" :label-width="formLabelWidth" prop="zdjecf">
											<el-radio-group v-model="kaipiaoform2.zdjecf">
												<el-radio label="0">按数量</el-radio>
												<el-radio label="1">按单价</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
								</div>
								<div class="kuang">
									<div class="forkuozhan between-line"><span>导入配置</span></div>
									<div class="Centerupdown ">
										<el-form-item label="导入覆盖方式" style="width: 300px;" label-width="110px"
											prop="daorfgfs">
											<el-radio-group v-model="kaipiaoform2.daorfgfs">
												<el-radio label="1">覆盖</el-radio>
												<el-radio label="2">拒绝</el-radio>
												<el-radio label="3">追加</el-radio>
											</el-radio-group>
										</el-form-item>
										<el-form-item label="导入计算方式" label-width="110px" prop="daorjsgz">
											<el-radio-group v-model="kaipiaoform2.daorjsgz">
												<el-radio label="1">数量*单价=金额</el-radio>
												<el-radio label="2">金额/数量=单价</el-radio>
												<el-radio label="3">金额/单价=数量</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
									<div class="Centerupdown ">
										<el-form-item label="客户主数据更新" label-width="110px" style="width: 300px;"
											prop="kehzsjgx">
											<el-radio-group v-model="kaipiaoform2.kehzsjgx">
												<el-radio label="1">更新</el-radio>
												<el-radio label="0">不更新</el-radio>
											</el-radio-group>
										</el-form-item>
										<el-form-item label="客户主数据关联" label-width="110px" prop="kehzsjgl">
											<el-radio-group v-model="kaipiaoform2.kehzsjgl">
												<el-radio label="0">不关联</el-radio>
												<el-radio label="1">客户名称关联</el-radio>
												<el-radio label="2">客户编码关联</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
									<div class="Centerupdown ">
										<el-form-item label="商品主数据关联" label-width="110px" prop="spzsjgl">
											<el-radio-group v-model="kaipiaoform2.spzsjgl">
												<el-radio label="0">不关联</el-radio>
												<el-radio label="1">商品名称关联</el-radio>
												<el-radio label="2">商品编码关联</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
								</div>
							</el-form>
						</div>
						<div v-if="choosekpindex == 3">
							<el-form class="demo-ruleForm" :disabled="!openaddseller" ref="kaipform3"
								label-width="100px" :rules="kaiprules" :model="kaipiaoform3">
								<div class="kuang">
									<div class="forkuozhan">手工拆分设置</div>
									<div class="Centerupdown ">
										<el-form-item label="含税标识:" prop="hansfs">
											<el-select v-model="kaipiaoform3.hansfs" style="width: 215px;" disabled>
												<el-option label="含税" value="1"></el-option>
												<el-option label="不含税" value="0"></el-option>
											</el-select>
										</el-form-item>
									</div>
									<div class="Centerupdown ">
										<el-form-item label="开票版本:" prop="zuidkpje">
											<el-select v-model="kaipiaoform3.zuidkpje" style="width: 215PX;">
												<el-option v-for="item in zuidkpjes" :key="item.value"
													:label="item.label" :value="item.value"></el-option>
											</el-select>
										</el-form-item>
										<el-form-item :label-width="formLabelWidth" label="最大开票明细数量:" prop="zuidkpmxsl">
											<el-input v-model="kaipiaoform3.zuidkpmxsl" style="width:215px"></el-input>
										</el-form-item>
									</div>
								</div>
								<div class="kuang">
									<div class="forkuozhan">计算方式设置</div>
									<div class="Centerupdown ">
										<el-form-item label="单价精度:" prop="danjjd"><el-input
												v-model="kaipiaoform3.danjjd"
												style="width:110px"></el-input></el-form-item>
										<el-form-item label-width="100px" label="数量精度:" prop="shuljd">
											<el-input v-model="kaipiaoform3.shuljd" style="width:110px"></el-input>
										</el-form-item>
										<el-form-item label="最大拆分方式" :label-width="formLabelWidth" prop="zdjecf">
											<el-radio-group v-model="kaipiaoform3.zdjecf">
												<el-radio label="0">按数量</el-radio>
												<el-radio label="1">按单价</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
								</div>
								<div class="kuang">
									<div class="forkuozhan between-line"><span>导入配置</span></div>
									<div class="Centerupdown ">
										<el-form-item label="导入覆盖方式" style="width: 300px;" label-width="110px"
											prop="daorfgfs">
											<el-radio-group v-model="kaipiaoform3.daorfgfs">
												<el-radio label="1">覆盖</el-radio>
												<el-radio label="2">拒绝</el-radio>
												<el-radio label="3">追加</el-radio>
											</el-radio-group>
										</el-form-item>
										<el-form-item label="导入计算方式" label-width="110px" prop="daorjsgz">
											<el-radio-group v-model="kaipiaoform3.daorjsgz">
												<el-radio label="1">数量*单价=金额</el-radio>
												<el-radio label="2">金额/数量=单价</el-radio>
												<el-radio label="3">金额/单价=数量</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
									<div class="Centerupdown ">
										<el-form-item label="客户主数据更新" label-width="110px" style="width: 300px;"
											prop="kehzsjgx">
											<el-radio-group v-model="kaipiaoform3.kehzsjgx">
												<el-radio label="1">更新</el-radio>
												<el-radio label="0">不更新</el-radio>
											</el-radio-group>
										</el-form-item>
										<el-form-item label="客户主数据关联" label-width="110px" prop="kehzsjgl">
											<el-radio-group v-model="kaipiaoform3.kehzsjgl">
												<el-radio label="0">不关联</el-radio>
												<el-radio label="1">客户名称关联</el-radio>
												<el-radio label="2">客户编码关联</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
									<div class="Centerupdown ">
										<el-form-item label="商品主数据关联" label-width="110px" prop="spzsjgl">
											<el-radio-group v-model="kaipiaoform3.spzsjgl">
												<el-radio label="0">不关联</el-radio>
												<el-radio label="1">商品名称关联</el-radio>
												<el-radio label="2">商品编码关联</el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
								</div>
							</el-form>
						</div>
					</div>
				</div>
				<div style="width: 100%;max-height: 400px; overflow-y: auto;" class="horizontally"
					v-if="chooseheadindex == 3">
					<el-form class="demo-ruleForm" ref="kaipform0" style="width: 100%" label-width="100px"
						:rules="kaiprules" :model="invoiceFormatForm">
						<div class="kuang" style="width: 80%;margin:0 auto">
							<div class="forkuozhan">下载版式配置</div>
							<div class="Centerupdown ">
								<el-form-item label="包含联次" style="width: 100%;" label-width="110px"
									prop="downloadContainsPagesType">
									<el-checkbox-group :disabled="!openaddseller"
										v-model="invoiceFormatForm.downloadContainsPagesType">
										<el-checkbox label="0" disabled>发票联</el-checkbox>
										<el-checkbox label="1">抵扣联</el-checkbox>
										<el-checkbox label="2">记账联</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
							</div>
							<div class="Centerupdown ">
								<el-form-item label="三联命名" label-width="110px" prop="downloadContainsPagesName">
									<el-radio-group :disabled="!openaddseller"
										v-model="invoiceFormatForm.downloadContainsPagesName">
										<el-radio label="0">联次</el-radio>
										<el-radio label="1">号码</el-radio>
									</el-radio-group>
								</el-form-item>
							</div>
						</div>

						<div class="kuang" style="width: 80%;margin:10px auto">
							<div class="forkuozhan">递送版式配置</div>
							<div class="Centerupdown ">
								<el-form-item label="包含联次" style="width: 100%;" label-width="110px"
									prop="sendContainsPagesType">
									<el-checkbox-group :disabled="!openaddseller"
										v-model="invoiceFormatForm.sendContainsPagesType">
										<el-checkbox label="0" disabled>发票联</el-checkbox>
										<el-checkbox label="1">抵扣联</el-checkbox>
										<el-checkbox label="2">记账联</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
							</div>
							<div class="Centerupdown ">
								<el-form-item label="三联命名" label-width="110px" prop="sendContainsPagesName">
									<el-radio-group :disabled="!openaddseller"
										v-model="invoiceFormatForm.sendContainsPagesName">
										<el-radio label="0">联次</el-radio>
										<el-radio label="1">号码</el-radio>
									</el-radio-group>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>

				<div style="width: 100%;max-height: 400px; overflow-y: auto;" class="horizontally"
					v-if="chooseheadindex == 4">
					<el-form class="demo-ruleForm" :disabled="!openaddseller" label-width="110px">
						<div class="Centerupdown">
							<el-form-item label="CA证书:" :label-width="formLabelWidth">
								<div class="Centerupdown">
									<el-input style="width: 300px;margin-right: 16px;" disabled
										v-model="this.fileName.zhengshuName"></el-input>
									<label style="display: flex;align-items: center;">
										<div class="Centerhorizontally bt1">选择文件</div>
										<input type="file" class="sendinput" @change="uploadFile($event, 'zhengshu')"
											:value="zhengshu" />
									</label>
								</div>
								<span style="color:#FFDC35;font-size:15px;cursor:default;"
									v-if="!this.notemptyandnull(this.dzqzFrom.zhengshuFile)">CA证书未上传!</span>
								<span style="color:#14E23A;cursor:default;"
									v-if="this.notemptyandnull(this.dzqzFrom.zhengshuFile)">CA证书已上传!</span>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="签章密码(CA):" :label-width="formLabelWidth">
								<el-input type="password" auto-complete="off" v-model="dzqzFrom.zsmm"
									style="width:300px"></el-input>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="过期日期:" :label-width="formLabelWidth">
								<div class="Centerupdown">
									<el-date-picker style="width: 300px;" v-model="dzqzFrom.zsdqrq" type="month"
										value-format="yyyyMMdd"></el-date-picker>
								</div>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="公司图章:" :label-width="formLabelWidth">
								<div class="Centerupdown">
									<el-input style="width: 300px;margin-right: 16px;" disabled
										v-model="this.fileName.cwtzName"></el-input>

									<label style="display: flex;align-items: center;">
										<div class="Centerhorizontally bt1">选择文件</div>
										<input type="file" class="sendinput" @change="uploadFile($event, 'cwtz')"
											:value="cwtz" />
									</label>
								</div>
								<sapn><img id="cwctImg" width="180" height="100" :src="imageSrc" /></sapn>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="发票图章:" :label-width="formLabelWidth">
								<div class="Centerupdown">
									<el-input style="width: 300px;margin-right: 16px;" disabled
										v-model="this.fileName.fptzName"></el-input>

									<label style="display: flex;align-items: center;">
										<div class="Centerhorizontally bt1">选择文件</div>
										<input type="file" class="sendinput" @change="uploadFile($event, 'fptz')"
											:value="fptz" />
									</label>
								</div>
								<sapn><img id="fptzImg" width="180" height="100" :src="fptzImgSrc" /></sapn>
							</el-form-item>
						</div>
					</el-form>
				</div>
				<!-- <AllElectricity v-show="chooseheadindex == 5" ref="avatar" :jbrxxList="jbrxxList" :isOpenType="isOpenType"></AllElectricity> -->
				<LejiDirectConnection v-show="chooseheadindex == 5" ref="Lejiref" :jbrxxList="jbrxxList"
					:naturalDirect="naturalDirect" :isOpenType="isOpenType" :jbxxdiag="jbxxdiag"
					:digitalRpaInfo='digitalRpaInfo'></LejiDirectConnection>
			</div>
			<div style="margin-top: 30px;padding-bottom: 28px;" class="between-line">
				<div></div>
				<div style="justify-content: right; display: flex;margin-top: 30px;">
					<!--          <div v-if="choosemainindex == 0  &&chooseheadindex==1 && isOpenType==2" @click="taxBureauSynchronization()"-->
					<!--               style="background: #0080FF;color: #FFFFFF;border: 0px;">税局同步-->
					<!--          </div>-->
					<div class="addstyle" v-if="isOpenType != 1" @click="forsumit(chooseheadindex)"
						style="width: 80px;margin-left: 20px;">提交</div>
					<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="jbxxdiag = false">关闭</div>
				</div>
			</div>
		</el-dialog>
		<minhead :headtitle="headtitle"></minhead>
		<div class="areacontent">
			<div class="between-line">
				<div class="Centerupdown">
					<!-- <el-button type="primary" plain style="width: 100px;" @click="foradd" :disabled="useropj.roleType != '1'">
						新建
						<i class="el-icon-circle-plus-outline el-icon--right"></i>
					</el-button> -->
					<div class="addstyle" style="width: 100px; margin-right: 10px;" @click="foradd"
						:disabled="useropj.roleType <= '1'" v-if="useropj.roleType <= '1'">
						<samp>
							新建
							<i class="el-icon-circle-plus-outline el-icon--right"></i>
						</samp>
					</div>
				</div>
				<div class="Centerupdown">
					<el-input clearable style="width: 200px;margin-left: 20px;margin-right: 16px;" placeholder="纳税人名称"
						prefix-icon="el-icon-search" v-model="serchval" @input="forserchcom"></el-input>
				</div>
			</div>
			<div class="areatable">
				<div class="tableh">
					<el-table :data="tableData" ref="multipleTable" border style="width: 100%"
						height="calc(100vh - 262px )">
						<el-table-column prop="code" label="企业代码" align="center"></el-table-column>
						<el-table-column prop="name" label="纳税人名称" align="center"></el-table-column>
						<el-table-column prop="taxNumber" label="纳税人识别号" align="center"></el-table-column>
						<el-table-column prop="state" label="启用状态" align="center"
							:formatter="stateFormat"></el-table-column>
						<el-table-column fixed="right" label="操作" width="180" align="center">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="forsee(scope.row)">查看</el-button>
								<el-button type="text" size="small" @click="forupdate(scope.row)"
									v-show="useropj.roleType <= '2'">编辑</el-button>
								<!--<el-button type="text" size="small" style="color: #ABABAB;">停用</el-button>-->
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="buttompage">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:page-sizes="[10, 20, 100, 500]" :key="elementui_page_component_key" :current-page="currentpage"
						:page-size="pagenum" layout="total, sizes, prev, pager, next, jumper"
						:total="totalcount"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import AllElectricity from './AllElectricity/index.vue';
	import LejiDirectConnection from './LejiDirectConnection/index.vue';
	export default {
		components: {
			AllElectricity,
			LejiDirectConnection
		},
		filters: {
			getArea(area) {
				return String(area).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			}
		},
		data() {
			var verifNum = (rule, value, callback) => {
				var reg = /^[0-9]+$/gi; //
				if (!reg.test(value)) {
					callback(new Error('只能输入数字'));
				} else {
					callback();
				}
			};
			var verifTxt = (rule, value, callback) => {
				var reg = /^[\u4e00-\u9fa5A-z0-9]+$/gi; //
				if (!reg.test(value)) {
					callback(new Error('只能输入汉字和字母、数字'));
				} else {
					callback();
				}
			};
			var verifLetterAndNum = (rule, value, callback) => {
				var reg = /^[\u4e00-\u9fa5A-z0-9_-]+$/gi; //
				if (!reg.test(value)) {
					callback(new Error('只能输入字母、数字、连接符'));
				} else {
					callback();
				}
			};
			var verifPhoneNumber = (rule, value, callback) => {
				var reg = /^1[0-9]{10}$/gi; //
				if (!reg.test(value) && value) {
					callback(new Error('请输入正确手机号'));
				} else {
					callback();
				}
			};
			var validateNasrsbhInfo = (rule, value, callback) => {
				var reg = /^[A-z0-9]+$/gi; //
				if (!reg.test(value)) {
					callback(new Error('只能输入字母和数字'));
				} else {
					if (value.length == '15' || value.length == '18' || value.length == '20') {
						callback();
					} else {
						callback(new Error('只能输入15,18,20长度的字母和数字'));
					}
				}
			};
			return {
				jbrxxList: [],
				naturalDirect: {},
				xqdiag: false,
				radiochange: '',
				useropj: '',
				tableHeight: '',
				kpjFrom: {
					piaojilist: []
				},
				currentpage: 1,
				elementui_page_component_key: '',
				/* 主信息还是开票机设置 */
				choosemainindex: 0,
				/* 电子专票还是电子普票 */
				choosekpindex: 0,
				isOpenType: 0,
				openaddseller: false,
				checkedRow: {},
				/* 基本信息 */
				jbrules: {
					/*code: [{validator: verifLetterAndNum,message: '只能输入字母和数字', trigger: 'blur' },
                { required: true, message: '请填写企业编码', trigger: 'blur' }],*/
					qiybh: [{
						required: true,
						message: '请填写公司代码',
						trigger: 'blur'
					}, {
						validator: verifLetterAndNum,
						message: '只能输入字母和数字',
						trigger: 'blur'
					}],
					type: [{
						message: '请填写纳税人类型',
						trigger: 'blur'
					}],
					bankAccount: [{
						required: true,
						message: '请填写开户行及账号',
						trigger: 'blur'
					}],
					addressPhone: [{
						required: true,
						message: '请填写地址、电话',
						trigger: 'blur'
					}],
					//authKey: [{ required: true, message: '请填写授权密钥', trigger: 'blur' }],
					taxNumber: [{
						validator: validateNasrsbhInfo,
						trigger: 'blur',
						required: true
					}],
					name: [{
						required: true,
						message: '请填写纳税人名称',
						trigger: 'blur'
					}],
					email: [{
						type: 'email',
						message: '邮箱格式不正确',
						trigger: 'blur'
					}],
					phoneNumber: [{
						validator: verifPhoneNumber,
						trigger: 'blur'
					}]
					/*					contact: [{ required: true, message: '长度', trigger: 'blur' }],
                            phoneNumber: [{ required: true, message: '请填写纳税人名称', trigger: 'blur' }],
                            email: [{ required: true, message: '请填写纳税人名称', trigger: 'blur' }],
                            position: [{ required: true, message: '请填写纳税人名称', trigger: 'blur' }],*/
				},

				jibenform: {
					code: '',
					name: '',
					taxNumber: '',
					qiybh: '',
					type: '',
					bankAccount: '',
					addressPhone: '',
					contact: '',
					phoneNumber: '',
					position: '',
					email: '',
					state: '',
					authKey: '',
					qixbMhkg: '',
					qixbZlkg: '',
					shengf: '',
					cczdjq: '0'
				},

				ibenformNew: {
					code: '',
					name: '',
					taxNumber: '',
					qiybh: '',
					type: '0',
					bankAccount: '',
					addressPhone: '',
					contact: '',
					phoneNumber: '',
					position: '',
					email: '',
					state: '0',
					authKey: '',
					qixbMhkg: '0',
					qixbZlkg: '0'
				},
				/* 开票信息 */

				xxiangform: {
					shuiksbh: '',
					dailsbh: '',
					xunsbh: '',
					xunsbkn: '',
					kaipbz: '',
					dengjxh: '',
					xiaogmkjzpbs: '',
					tedqy: '',
					jinxsqbz: '',
					shengf: '',
					version: '',
					qingqfs: ''
				},
				kaipiaoformData: [],
				/* 开票规则 */
				formLabelWidth: '180px',
				jbxxdiag: false,
				page: 1,
				pagenum: 10,
				totalcount: 10,
				tableData: [],
				jbxxtitle: ['基本信息'],
				headtitle: ['系统设置', '实体设置'],
				serchval: '',
				chooseheadindex: 0,
				jbheadlist: [{
						title: '基本信息'
					},
					{
						title: '开票信息'
					},
					{
						title: '开票规则'
					},
					{
						title: '发票版式'
					},
					{
						title: '签章信息'
					},
					// {
					// 	title: '数电管理'
					// },
					{
						title: '数电管理'
					}
				],
				mainlist: [
					// {
					//     title: '主信息'
					// },
					// {
					//   title: '开票机设置'
					// }
				],
				kplist: [{
						title: '电子普票'
					},
					{
						title: '电子专票'
					},
					{
						title: '纸质专票'
					},
					{
						title: '纸质普票'
					}
					// ,
					// { title: '数电管理' }
				],
				//开票数据
				kaiprules: {
					hansfs: [{
						required: true,
						message: '请选择含税方式',
						trigger: 'blur'
					}],
					zuidkpje: [{
						required: true,
						message: '请填写开票限额',
						trigger: 'blur'
					}],
					danjjd: [{
						required: true,
						message: '请填写单价精度',
						trigger: 'blur'
					}],
					shuljd: [{
						required: true,
						message: '请填写数量精度',
						trigger: 'blur'
					}],
					zdjecf: [{
						required: true,
						message: '请选择最大拆分方式',
						trigger: 'blur'
					}],
					daorfgfs: [{
						required: true,
						message: '请选择导入覆盖方式',
						trigger: 'blur'
					}],
					daorjsgz: [{
						required: true,
						message: '请选择导入计算方式',
						trigger: 'blur'
					}],
					kehzsjgx: [{
						required: true,
						message: '请选择客户主数据更新方式',
						trigger: 'blur'
					}],
					kehzsjgl: [{
						required: true,
						message: '请选择客户主数据关联方式',
						trigger: 'blur'
					}],
					spzsjgl: [{
						required: true,
						message: '请选择商品主数据关联方式',
						trigger: 'blur'
					}]
				},
				kaipiaoform0: {
					hansfs: '0',
					zuidkpje: 9999.99,
					zuidkpmxsl: 100,
					danjjd: '0.01',
					shuljd: '0.01',
					zdjecf: '0',
					daorfgfs: '1',
					daorjsgz: '1',
					kehzsjgx: '0',
					kehzsjgl: '0',
					spzsjgl: '0',
					id: '0',
					version: '0'
				},
				kaipiaoform1: {
					hansfs: '0',
					zuidkpje: 9999.99,
					zuidkpmxsl: 100,
					danjjd: '0.01',
					shuljd: '0.01',
					zdjecf: '0',
					daorfgfs: '1',
					daorjsgz: '1',
					kehzsjgx: '0',
					kehzsjgl: '0',
					spzsjgl: '0',
					id: '0',
					version: '0'
				},
				kaipiaoform2: {
					hansfs: '0',
					zuidkpje: 9999.99,
					zuidkpmxsl: 100,
					danjjd: '0.01',
					shuljd: '0.01',
					zdjecf: '0',
					daorfgfs: '1',
					daorjsgz: '1',
					kehzsjgx: '0',
					kehzsjgl: '0',
					spzsjgl: '0',
					id: '0',
					version: '0'
				},
				kaipiaoform3: {
					hansfs: '0',
					zuidkpje: 9999.99,
					zuidkpmxsl: 100,
					danjjd: '0.01',
					shuljd: '0.01',
					zdjecf: '0',
					daorfgfs: '1',
					daorjsgz: '1',
					kehzsjgx: '0',
					kehzsjgl: '0',
					spzsjgl: '0',
					id: '0',
					version: '0'
				},

				defkaipiaoform: {
					hansfs: '0',
					zuidkpje: '9999.99',
					danjjd: '0.01',
					shuljd: '0.01',
					zdjecf: '0',
					daorfgfs: '1',
					daorjsgz: '1',
					kehzsjgx: '0',
					kehzsjgl: '0',
					spzsjgl: '0',
					id: '0',
					version: '0'
				},
				selectShengf: [],
				dzqzFrom: {
					zhengshuFile: '',
					zsdqrq: '',
					zsmm: '',
					cwtzFile: '',
					fptzFile: ''
				},
				fileName: {
					zhengshuName: '',
					cwtzName: '',
					fptzName: ''
				},
				cwtz: '',
				zhengshu: '',
				imgFile: '',
				zuidkpjes: [{
						label: '万元版（不含税￥9,999.99）',
						value: 9999.99
					},
					{
						label: '十万元版（不含税99,999.99）',
						value: 99999.99
					},
					{
						label: '百万元版（不含税999,999.99）',
						value: 999999.99
					},
					{
						label: '千万元版（不含税9,999,999.99）',
						value: 9999999.99
					}
				],
				imageSrc: 'data:image/gif;base64,',
				fptz: '',
				fptzImgSrc: 'data:image/gif;base64,',
				kpjform: {
					equipmentType: '',
					kaipjbh: '',
					kaipjmc: '',
					mainNo: '',
					management: '1',
					tunnelName: '3',
					kaipr: '',
					fuhr: '',
					shoukr: '',
					queskpj: '',
					allowFplx: [],
					qiybh: ''
				},
				kpjtitle: ['税盘信息'],
				isaddkpj: false,
				kpjdata: [],
				formlist: [{
						prop: 'equipmentType',
						label: '设备类型:',
						type: 'select',
						selectval: [{
								label: '金税盘',
								value: '0'
							},
							{
								label: '税控盘',
								value: '2'
							},
							{
								label: '税务Ukey',
								value: '1'
							}
						],
						isnotnull: true
					},
					{
						prop: 'kaipjbh',
						label: '开票机编号',
						type: 'input',
						isnotnull: true,
						inputinput: true
					},
					{
						prop: 'kaipjmc',
						label: '开票机名称',
						type: 'input',
						isnotnull: true
					},
					{
						prop: 'mainNo',
						label: '主/分盘号',
						type: 'input',
						isnotnull: true,
						inputinput: true,
						placeholder: '如果无分盘号,填0'
					},
					// {
					//   prop: "management",
					//   label: "税盘托管方式",
					//   type: "radio",
					//   radioval:[{
					//     label: "自持",
					//     value: "0"
					//   },
					//     {
					//       label: "托管",
					//       value: "1"
					//     }],
					//   isnotnull: true,
					//   radiochange: true
					// },
					// {
					//   prop: "tunnelName",
					//   label: "自持/托管设备:",
					//   type: "select",
					//   selectval:[
					//     {
					//       label:"云小开助手",
					//       value:"1"
					//     },
					//     {
					//       label:"组件",
					//       value:"2"
					//     }
					//   ],
					//   isnotnull: true,
					// },
					{
						prop: 'kaipr',
						label: '默认开票人',
						type: 'input'
						// ,isnotnull: true
					},
					{
						prop: 'fuhr',
						label: '默认复核人',
						type: 'input'
						// ,isnotnull: true
					},
					{
						prop: 'shoukr',
						label: '默认收款人',
						type: 'input'
						// ,isnotnull: true
					},
					// {
					//   prop: "queskpj",
					//   label: "是否默认",
					//   type: "radio",
					//   radioval:[{
					//     label: "不是",
					//     value: "0"
					//   },
					//     {
					//       label: "是",
					//       value: "1"
					//     }],
					//   isnotnull: true
					// },
					{
						prop: 'allowFplx',
						label: '发票类型',
						type: 'checkbox',
						checkboxval: [{
								label: '电子普票',
								value: '026'
							},
							{
								label: '电子专票',
								value: '028'
							},
							{
								label: '纸质专票',
								value: '004'
							},
							{
								label: '纸质普票',
								value: '007'
							}
						],
						isnotnull: true
					}
				],
				HeadData: [
					// {
					//   title: "默认",
					//   prop: "queskpj",
					//   width:50,
					//   custom: true
					// },
					{
						title: '设备类型',
						prop: 'equipmentType',
						align: 'left',
						width: 80,
						custom: true
					},
					{
						title: '设备编号',
						prop: 'kaipjbh',
						width: 80,
						align: 'left'
					},
					// {
					//   title: "设备名称",
					//   prop: "kaipjmc",
					//   align:"left"
					// },
					{
						title: '主/分盘号',
						prop: 'mainNo',
						width: 80,
						align: 'left'
					},
					{
						title: '税盘管理方式',
						prop: 'management',
						align: 'left',
						width: 100,
						custom: true
					},
					{
						title: '默认开票人',
						prop: 'kaipr',
						width: 90,
						align: 'left'
					},
					{
						title: '默认复核人',
						prop: 'fuhr',
						width: 90,
						align: 'left'
					},
					{
						title: '默认收款人',
						prop: 'shoukr',
						width: 90,
						align: 'left'
					},
					{
						title: '操作',
						width: 120,
						prop: 'cz',
						custom: true,
						align: 'left'
					}
				],
				isAddCompany: false, //是否重新打开新建页面标识

				oneformlist: [{
						prop: 'kpjzrq',
						label: '开票截止日期:',
						type: 'input',
						inputinput: true,
						istosee: true
					},
					{
						prop: 'sjbsqsrq',
						label: '数据报送起始日期:',
						type: 'input',
						inputinput: true,
						istosee: true
					},
					{
						prop: 'sjbszzrq',
						label: '数据报送终止日期:',
						type: 'input',
						inputinput: true,
						istosee: true
					},
					{
						prop: 'zxbsrq',
						label: '最新报税日期:',
						type: 'input',
						inputinput: true,
						istosee: true
					},
					{
						prop: 'scjzrq',
						label: '上传截止日期:',
						type: 'input',
						istosee: true
					},
					{
						prop: 'lxkpsc',
						label: '离线开票时长:',
						type: 'input',
						istosee: true
					},
					{
						prop: 'lxljje',
						label: '离线累计金额(元):',
						type: 'input',
						istosee: true
					}
				],
				formdata: {
					kpjzrq: '',
					sjbsqsrq: '',
					sjbszzrq: '',
					zxbsrq: '',
					scjzrq: '',
					lxkpsc: '',
					lxljje: ''
				},
				faplxdm: '',
				oneKpxe: '',
				options: [],
				fplxlist: [{
					label: '纸质专票',
					value: '004'
				}, {
					label: '纸质普票',
					value: '007'
				}, {
					label: '电子普票',
					value: '026'
				}, {
					label: '电子专票',
					value: '028'
				}],
				kpjDetailsList: [],
				invoiceFormatForm: {
					id: '',
					downloadContainsPagesType: ['0'],
					sendContainsPagesType: ['0'],
					downloadContainsPagesName: '0',
					sendContainsPagesName: '0'
				},

				digitalRpaInfo: null,
			};
		},
		created() {
			this.useropj = JSON.parse(localStorage.getItem('useropj'));
			this.getCompanyList(this.useropj.companyGroupId);
			this.initShengf();
			// this.getkpjList();
		},
		mounted() {
			this.$nextTick(() => {
				this.tableHeight = this.diagheight();
				this.$refs.multipleTable.doLayout();
				window.onresize = () => {
					this.tableHeight = this.diagheight();
					this.$refs.multipleTable.doLayout();
				};
			});
		},
		methods: {
			/* 	添加开票机 */
			addthis() {
				console.log(this.radiochange);
				this.kpjFrom.piaojilist.push({
					kaipjmc: '主盘',
					kaipjbh: '0001'
				});
				console.log(this.kpjFrom.piaojilist.length);
				if (this.kpjFrom.piaojilist.length == 1) {
					this.radiochange = 1;
				}
				console.log(this.radiochange);
			},
			fordelete(index) {
				this.kpjFrom.piaojilist.splice(index, 1);
			},
			changekpindex(index) {
				this.choosekpindex = index;
			},
			changemainindex(index) {
				this.choosemainindex = index;
			},
			changeindex(index) {
				this.chooseheadindex = index;
			},
			/* 提交基本信息表单 */
			forsumit(index) {
				// for (var i = 0; i < this.$refs.Lejiref.HandlerInformationData.length; i++) {
				// 	console.log(this.$refs.Lejiref.HandlerInformationData.length);
				// 	console.log(this.$refs.Lejiref.HandlerInformationData[i].xingm);
				// 	if (!this.$refs.Lejiref.HandlerInformationData[i].xingm) {
				// 		this.$message.error('（数电）异常提示:姓名不能为空.');
				// 		return;
				// 	}
				// 	if (!this.$refs.Lejiref.HandlerInformationData[i].guoj) {
				// 		this.$message.error('（数电）异常提示:国籍不能为空.');
				// 		return;
				// 	}
				// 	if (!this.$refs.Lejiref.HandlerInformationData[i].zhengjlx) {
				// 		this.$message.error('（数电）异常提示:证件类型不能为空.');
				// 		return;
				// 	}
				// 	if (!this.$refs.Lejiref.HandlerInformationData[i].zhengjhm) {
				// 		this.$message.error('（数电）异常提示:证件号码不能为空.');
				// 		return;
				// 	}
				// 	if (!this.$refs.Lejiref.HandlerInformationData[i].zirrnsrsbh) {
				// 		this.$message.error('（数电）异常提示:自然人纳税人识别号不能为空.');
				// 		return;
				// 	}
				// }
				let phonePattern = /^1[3-9]\d{9}$/;
				let emailPattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
				if (this.$refs.Lejiref.qrReceiveWay.length == 1) {
					if (this.$refs.Lejiref.qrReceiveWay[0] == '1') {
						if (!phonePattern.test(this.$refs.Lejiref.phone)) {
							this.$message.error('（数电管理）异常提示:人脸识别信息认证二维码接受方式手机号错误.');
							return;
						}
					} else {
						if (!emailPattern.test(this.$refs.Lejiref.email)) {
							this.$message.error('（数电管理）异常提示:人脸识别信息认证二维码接受方式邮箱错误.');
							return;
						}
					}
				} else if (this.$refs.Lejiref.qrReceiveWay.length == 2) {
					if (!phonePattern.test(this.$refs.Lejiref.phone)) {
						this.$message.error('（数电管理）异常提示:人脸识别信息认证二维码接受方式手机号错误.');
						return;
					}
					if (!emailPattern.test(this.$refs.Lejiref.email)) {
						this.$message.error('（数电管理）异常提示:人脸识别信息认证二维码接受方式邮箱错误.');
						return;
					}
				}


				if (!this.isFormValidate(1)) {
					return;
				}
				if (this.isOpenType == 0) {
					//添加
					let jibenformparams = JSON.parse(JSON.stringify(this.jibenform));
					jibenformparams.groupId = this.useropj.companyGroupId;
					let formData = new FormData();
					formData.append('company', JSON.stringify(jibenformparams));

					//开票信息
					this.xxiangform.shengf = jibenformparams.shengf;
					this.xxiangform = JSON.parse(JSON.stringify(this.xxiangform));
					let xxiangformparams = this.xxiangform;
					xxiangformparams.qiybh = jibenformparams.code;
					xxiangformparams.nasrsbh = jibenformparams.taxNumber;
					xxiangformparams.nasrmc = jibenformparams.name;
					delete xxiangformparams.updateTime;
					delete xxiangformparams.createTime;
					xxiangformparams.shudfpkpfs = this.$refs.Lejiref.shudfpkpfs;
					formData.append('stxx', JSON.stringify(xxiangformparams));
					for (let id = 0; id < this.kpjFrom.piaojilist.length; id++) {
						this.kpjFrom.piaojilist[id].qiybh = jibenformparams.code;
						this.kpjFrom.piaojilist[id].nasrsbh = jibenformparams.taxNumber;
						this.kpjFrom.piaojilist[id].nasrmc = jibenformparams.name;
						if (this.radiochange == id + 1) {
							this.kpjFrom.piaojilist[id].queskpj = '1';
						} else {
							this.kpjFrom.piaojilist[id].queskpj = '0';
						}
					}
					formData.append('kpjList', JSON.stringify(this.kpjFrom.piaojilist));
					this.kaipiaoform0.faplx = '026';
					this.kaipiaoform0.qiybh = jibenformparams.code;
					this.kaipiaoform0.nasrsbh = jibenformparams.taxNumber;
					this.kaipiaoform0.nasrmc = jibenformparams.name;
					this.kaipiaoform1.faplx = '028';
					this.kaipiaoform1.qiybh = jibenformparams.code;
					this.kaipiaoform1.nasrsbh = jibenformparams.taxNumber;
					this.kaipiaoform1.nasrmc = jibenformparams.name;
					this.kaipiaoform2.faplx = '004';
					this.kaipiaoform2.qiybh = jibenformparams.code;
					this.kaipiaoform2.nasrsbh = jibenformparams.taxNumber;
					this.kaipiaoform2.nasrmc = jibenformparams.name;
					this.kaipiaoform3.faplx = '007';
					this.kaipiaoform3.qiybh = jibenformparams.code;
					this.kaipiaoform3.nasrsbh = jibenformparams.taxNumber;
					this.kaipiaoform3.nasrmc = jibenformparams.name;
					formData.append('stxxFplxhd0', JSON.stringify(this.kaipiaoform0));
					formData.append('stxxFplxhd1', JSON.stringify(this.kaipiaoform1));
					formData.append('stxxFplxhd2', JSON.stringify(this.kaipiaoform2));
					formData.append('stxxFplxhd3', JSON.stringify(this.kaipiaoform3));
					this.invoiceFormatForm.code = this.checkedRow.code;
					formData.append('invoiceFormat', JSON.stringify(this.invoiceFormatForm));
					var dzqz = {};
					dzqz.qiybh = this.checkedRow.code;
					dzqz.zsdqrq = this.dzqzFrom.zsdqrq;
					dzqz.zsmm = this.dzqzFrom.zsmm;

					formData.append('dzqz', JSON.stringify(dzqz));
					formData.append('zhengshu', this.dzqzFrom.zhengshuFile);
					formData.append('cwtz', this.dzqzFrom.cwtzFile);
					//数电经办人信息
					if (this.$refs.Lejiref.HandlerInformationData.length > 0) {
						let tableData = this.$refs.Lejiref.HandlerInformationData;
						tableData = this.$refs.Lejiref.HandlerInformationData.map(v => {
							v.qiybh = jibenformparams.code;
							return v;
						});
						console.log(tableData);
						formData.append('jbrxxList', JSON.stringify(tableData));
					}
					//数电乐企信息
					formData.append('naturalDirect', JSON.stringify(this.$refs.Lejiref.formdata));

					//数电RPA
					let rpaFormData = this.$refs.Lejiref.rpaformdata;
					rpaFormData.rpaWay = this.$refs.Lejiref.rpaWay;
					rpaFormData.qrReceiveWay = this.$refs.Lejiref.qrReceiveWay.join(",");
					rpaFormData.phone = this.$refs.Lejiref.phone;
					rpaFormData.email = this.$refs.Lejiref.email;
					formData.append('digitalRpaInfo', JSON.stringify(rpaFormData));
					//保存实体
					this.$https.fetchPost('sys/admin/saveStxxPojo', formData).then(res => {
						if (res.data.success) {
							this.getCompanyList(this.useropj.companyGroupId);
							this.jbxxdiag = false;
							this.getCompanyList(this.useropj.companyGroupId);
							this.isAddCompany = false;
						}
					});
				} else if (this.isOpenType == 2) {
					let formData = new FormData();
					//公司信息
					let jibenformparams = this.jibenform;
					jibenformparams.groupId = this.useropj.companyGroupId;
					jibenformparams.version = this.checkedRow.version;
					jibenformparams.id = this.checkedRow.id;
					delete jibenformparams.companyGroup;
					delete jibenformparams.createTime;
					delete jibenformparams.updateTime;
					formData.append('company', JSON.stringify(jibenformparams));
					//开票信息
					this.xxiangform.shengf = jibenformparams.shengf;
					this.xxiangform = JSON.parse(JSON.stringify(this.xxiangform));
					let xxiangformparams = this.xxiangform;
					xxiangformparams.qiybh = this.checkedRow.code;
					xxiangformparams.nasrsbh = this.checkedRow.taxNumber;
					xxiangformparams.nasrmc = this.checkedRow.name;
					delete xxiangformparams.updateTime;
					delete xxiangformparams.createTime;
					xxiangformparams.shudfpkpfs = this.$refs.Lejiref.shudfpkpfs;
					formData.append('stxx', JSON.stringify(xxiangformparams));
					//开票机
					for (let id = 0; id < this.kpjFrom.piaojilist.length; id++) {
						this.kpjFrom.piaojilist[id].qiybh = this.checkedRow.code;
						this.kpjFrom.piaojilist[id].nasrsbh = this.checkedRow.taxNumber;
						this.kpjFrom.piaojilist[id].nasrmc = this.checkedRow.name;
						if (this.radiochange == id + 1) {
							this.kpjFrom.piaojilist[id].queskpj = '1';
						} else {
							this.kpjFrom.piaojilist[id].queskpj = '0';
						}
					}
					formData.append('kpjList', JSON.stringify(this.kpjFrom.piaojilist));
					//开票规则
					this.kaipiaoform0.faplx = '026';
					this.kaipiaoform0.qiybh = this.checkedRow.code;
					this.kaipiaoform0.nasrsbh = this.checkedRow.taxNumber;
					this.kaipiaoform0.nasrmc = this.checkedRow.name;
					this.kaipiaoform1.faplx = '028';
					this.kaipiaoform1.qiybh = this.checkedRow.code;
					this.kaipiaoform1.nasrsbh = this.checkedRow.taxNumber;
					this.kaipiaoform1.nasrmc = this.checkedRow.name;
					this.kaipiaoform2.faplx = '004';
					this.kaipiaoform2.qiybh = this.checkedRow.code;
					this.kaipiaoform2.nasrsbh = this.checkedRow.taxNumber;
					this.kaipiaoform2.nasrmc = this.checkedRow.name;
					this.kaipiaoform3.faplx = '007';
					this.kaipiaoform3.qiybh = this.checkedRow.code;
					this.kaipiaoform3.nasrsbh = this.checkedRow.taxNumber;
					this.kaipiaoform3.nasrmc = this.checkedRow.name;
					formData.append('stxxFplxhd0', JSON.stringify(this.kaipiaoform0));
					formData.append('stxxFplxhd1', JSON.stringify(this.kaipiaoform1));
					formData.append('stxxFplxhd2', JSON.stringify(this.kaipiaoform2));
					formData.append('stxxFplxhd3', JSON.stringify(this.kaipiaoform3));
					var dzqz = {};
					dzqz.qiybh = this.checkedRow.code;
					dzqz.zsdqrq = this.dzqzFrom.zsdqrq;
					dzqz.zsmm = this.dzqzFrom.zsmm;

					formData.append('dzqz', JSON.stringify(dzqz));
					formData.append('zhengshu', this.dzqzFrom.zhengshuFile);
					formData.append('cwtz', this.dzqzFrom.cwtzFile);
					formData.append('fptz', this.dzqzFrom.fptzFile);
					this.invoiceFormatForm.code = this.checkedRow.code;
					formData.append('invoiceFormat', JSON.stringify(this.invoiceFormatForm));
					//数电经办人信息
					if (this.$refs.Lejiref.HandlerInformationData.length > 0) {
						let tableData = this.$refs.Lejiref.HandlerInformationData;
						tableData = this.$refs.Lejiref.HandlerInformationData.map(v => {
							v.qiybh = jibenformparams.code;
							return v;
						});
						console.log(tableData);
						formData.append('jbrxxList', JSON.stringify(tableData));
					}
					//数电乐企信息
					formData.append('naturalDirect', JSON.stringify(this.$refs.Lejiref.formdata));

					//数电RPA
					console.log(this.$refs.Lejiref.rpaformdata);
					let rpaFormData = this.$refs.Lejiref.rpaformdata;
					rpaFormData.rpaWay = this.$refs.Lejiref.rpaWay;
					rpaFormData.qrReceiveWay = this.$refs.Lejiref.qrReceiveWay.join(",");
					rpaFormData.phone = this.$refs.Lejiref.phone;
					rpaFormData.email = this.$refs.Lejiref.email;
					console.log(rpaFormData)
					formData.append('digitalRpaInfo', JSON.stringify(rpaFormData));

					this.$https.fetchPost('sys/admin/updateStxxPojo', formData).then(res => {
						if (res.data.success) {
							this.getCompanyList(this.useropj.companyGroupId);
							this.jbxxdiag = false;
							this.getCompanyList(this.useropj.companyGroupId);
						}
					});
				}
			},
			taxBureauSynchronization() {
				if (
					this.xxiangform.qingqfs == '1' &&
					(this.xxiangform.shuiksbh == '' || this.xxiangform.dailsbh == '' || this.xxiangform.xunsbh == '' ||
						this.xxiangform.xunsbkn == '')
				) {
					this.$message.error('暂未配置服务器信息');
					return;
				}
				let params = {
					shuiksbh: this.xxiangform.shuiksbh,
					dailsbh: this.xxiangform.dailsbh,
					xunsbh: this.xxiangform.xunsbh,
					xunsbkn: this.xxiangform.xunsbkn,
					qiybh: this.jibenform.code,
					nsrsbh: this.jibenform.taxNumber
				};
				this.$https.fetchPost('sys/admin/getSynchronizationByStxx', params).then(res => {
					if (res.data.success) {
						this.getCompanyList(this.useropj.companyGroupId);
						this.jbxxdiag = false;
						this.getCompanyList(this.useropj.companyGroupId);
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			foradd() {
				this.changeOpen();
				this.jbheadlist = [{
						title: '基本信息'
					},
					{
						title: '开票信息'
					},
					{
						title: '开票规则'
					},
					{
						title: '发票版式'
					},
					{
						title: '签章信息'
					},
					// { title: '数电管理' },
					{
						title: '数电管理'
					}
				];
				this.isOpenType = 0;
				this.jibenform = JSON.parse(JSON.stringify(this.ibenformNew));
				this.jibenform.qixbMhkg = '1';
				this.jibenform.qixbZlkg = '0';
				this.jibenform.cczdjq = '0';
				this.jbxxdiag = true;
				this.jbrxxList = [];

				this.$nextTick(() => {
					this.$refs.Lejiref.QjangKaj();
				});
				this.$nextTick(() => {
					this.$refs.Lejiref.ZHiZujian(this.isOpenType);
				});
				this.openaddseller = true;
				if (this.kpjFrom.piaojilist.length != 1) {
					this.addthis();
				}
				this.choosemainindex = 0;
				console.log(this.kpjFrom.piaojilist);
				this.kpjdata = [];
				this.isAddCompany = true;
			},
			forsee(e) {
				this.changeOpen();
				this.isOpenType = 1;
				this.selectDataByEdit(e);
				this.checkedRow = JSON.parse(JSON.stringify(e));
				this.jbheadlist = [{
						title: '基本信息'
					},
					{
						title: '开票信息'
					},
					{
						title: '开票规则'
					},
					{
						title: '发票版式'
					},
					{
						title: '签章信息'
					},
					// { title: '数电管理' },
					{
						title: '数电管理'
					}
				];
				this.openaddseller = false;
				this.getkpjList();
			},
			forupdate(e) {
				this.changeOpen();
				this.isOpenType = 2;
				this.selectDataByEdit(e);
				this.checkedRow = JSON.parse(JSON.stringify(e));
				this.jbheadlist = [{
						title: '基本信息'
					},
					{
						title: '开票信息'
					},
					{
						title: '开票规则'
					},
					{
						title: '发票版式'
					},
					{
						title: '签章信息'
					},
					// { title: '数电管理' },
					{
						title: '数电管理'
					}
				];
				this.openaddseller = true;
				this.jibenform.qixbZlkg = '0';
				if (this.kpjFrom.piaojilist.length != 1) {
					this.addthis();
				}
				console.log(this.kpjFrom.piaojilist);
				this.getkpjList();
				this.isAddCompany = false;
			},
			handleSizeChange(val) {
				this.pagenum = val;
				this.getCompanyList(this.useropj.companyGroupId);
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getCompanyList(this.useropj.companyGroupId);
			},
			// 根据集团找公司
			getCompanyList(e) {
				let id = e;
				if (id == '') {
					id = null;
				}
				let params = {
					search: {
						groupId: id
					},
					likeSearch: this.likeSearchCompany,
					page: this.page,
					limit: this.pagenum
				};
				this.$https.fetchPost('sys/admin/getCompanyListByState', params).then(res => {
					this.totalcount = res.data.count;
					this.tableData = res.data.data;
				});
			},
			stateFormat(row, column, cellValue, index) {
				if (row.state == '0') {
					return '正常';
				} else if (row.state == '1') {
					return '停用';
				} else {
					return row.state;
				}
			},
			forserchcom(e) {
				this.currentpage = 1;
				this.elementui_page_component_key++;
				this.page = 1;
				this.likeSearchCompany = JSON.parse(JSON.stringify(e));
				this.getCompanyList(this.useropj.companyGroupId);
			},
			selectDataByEdit(e) {
				this.jibenform = JSON.parse(JSON.stringify(e));
				this.$https.fetchPost('sys/admin/getCompanyStxx', this.jibenform.code).then(res => {
					if (res.data.obj.stxx) {
						this.xxiangform = res.data.obj.stxx;
						let stxx = JSON.parse(JSON.stringify(this.xxiangform));
						this.jibenform.shengf = stxx.shengf;
					}
					if (res.data.obj.jbrxxList) {
						this.jbrxxList = res.data.obj.jbrxxList;
					} else {
						this.jbrxxList = [{
							isBianj: true,
							xingm: '',
							guoj: '',
							zhengjlx: '',
							zhengjhm: '',
							zirrnsrsbh: '',
							shifmr: '0'
						}];
					}
					if (res.data.obj.naturalDirect) {
						this.naturalDirect = res.data.obj.naturalDirect;
					} else {
						this.naturalDirect = {
							accessUnitNaturalId: '',
							useCaseCoding: '',
							accessSignature: '',
							useUnitNaturalId: '',
							sandboxTestMark: ''
						};
					}
					if(res.data.obj.digitalRpaInfo){
						this.digitalRpaInfo = JSON.parse(JSON.stringify(res.data.obj.digitalRpaInfo));
					}else{
						this.digitalRpaInfo = {};
					}
					if (res.data.obj.stxx.shudfpkpfs) {
						// this.digitalRpaInfo.shudfpkpfs = res.data.obj.stxx.shudfpkpfs;
						this.digitalRpaInfo = Object.assign({}, this.digitalRpaInfo, {
							shudfpkpfs: res.data.obj.stxx.shudfpkpfs
						})
					} else {
						this.digitalRpaInfo = Object.assign({}, this.digitalRpaInfo, {
							shudfpkpfs: "1"
						})
					}
					this.jibenform = JSON.parse(JSON.stringify(this.jibenform));
					if (res.data.obj.kpjList) {
						console.log(res.data.obj.kpjList);

						for (var i = 0; i < res.data.obj.kpjList.length; i++) {
							if (res.data.obj.kpjList[i].queskpj == '1') {
								this.radiochange = i + 1;
							}
						}
						this.kpjFrom.piaojilist = res.data.obj.kpjList;
					}
					if (res.data.obj.stxxFplxhdList) {
						for (let i = 0; i < res.data.obj.stxxFplxhdList; i++) {
							if (res.data.obj.stxxFplxhdList[i].faplx == '026') {
								this.kaipiaoformData[0] = res.data.obj.stxxFplxhdList[i];
							} else if (res.data.obj.stxxFplxhdList[i].faplx == '028') {
								this.kaipiaoformData[1] = res.data.obj.stxxFplxhdList[i];
							} else if (res.data.obj.stxxFplxhdList[i].faplx == '004') {
								this.kaipiaoformData[2] = res.data.obj.stxxFplxhdList[i];
							} else if (res.data.obj.stxxFplxhdList[i].faplx == '007') {
								this.kaipiaoformData[3] = res.data.obj.stxxFplxhdList[i];
							}
						}
						// if (res.data.obj.stxxFplxhdList.length == 1) {
						//   let copyFplxhd = {};
						//   if (res.data.obj.stxxFplxhdList[0].faplx == '028') {
						//     res.data.obj.stxxFplxhdList.unshift(copyFplxhd);
						//   } else {
						//     res.data.obj.stxxFplxhdList.push(copyFplxhd);
						//   }
						// } else if (res.data.obj.stxxFplxhdList.length == 2) {
						//   if (res.data.obj.stxxFplxhdList[0].faplx == '028') {
						//     res.data.obj.stxxFplxhdList[0] = res.data.obj.stxxFplxhdList.splice(1, 1, res.data.obj.stxxFplxhdList[0])[0];
						//   }
						// }
						this.kaipiaoformData = res.data.obj.stxxFplxhdList;
						if (this.kaipiaoformData[0]) {
							this.kaipiaoform0 = this.kaipiaoformData[0];
						} else {
							this.kaipiaoform0 = JSON.parse(JSON.stringify(this.defkaipiaoform));
						}
						if (this.kaipiaoformData[1]) {
							this.kaipiaoform1 = this.kaipiaoformData[1];
						} else {
							this.kaipiaoform1 = JSON.parse(JSON.stringify(this.defkaipiaoform));
						}
						if (this.kaipiaoformData[2]) {
							this.kaipiaoform2 = this.kaipiaoformData[2];
						} else {
							this.kaipiaoform2 = JSON.parse(JSON.stringify(this.defkaipiaoform));
						}
						if (this.kaipiaoformData[3]) {
							this.kaipiaoform3 = this.kaipiaoformData[3];
						} else {
							this.kaipiaoform3 = JSON.parse(JSON.stringify(this.defkaipiaoform));
						}
						console.log(this.kaipiaoformData);
						//两个对象的字段不完全相同时
						// Object.keys(this.kaipiaoform0).forEach(key => {
						//   if (this.kaipiaoformData[0][key] != null) {
						//     this.kaipiaoform0[key] = this.kaipiaoformData[0][key];
						//   }
						// });
						// Object.keys(this.kaipiaoform1).forEach(key => {
						//   if (this.kaipiaoformData[1][key] != null) {
						//     this.kaipiaoform1[key] = this.kaipiaoformData[1][key];
						//   }
						// });
						// Object.keys(this.kaipiaoform2).forEach(key => {
						//   if (this.kaipiaoformData[2][key] != null) {
						//     this.kaipiaoform1[key] = this.kaipiaoformData[2][key];
						//   }
						// });
						// Object.keys(this.kaipiaoform3).forEach(key => {
						//   if (this.kaipiaoformData[3][key] != null) {
						//     this.kaipiaoform1[key] = this.kaipiaoformData[3][key];
						//   }
						// });
					}
					if (res.data.obj.dzqz) {
						var cwtzFileName = res.data.obj.dzqz.cwtzFileName;
						if (this.notemptyandnull(cwtzFileName)) {
							var fileType = cwtzFileName.substring(cwtzFileName.lastIndexOf('.') + 1, cwtzFileName
								.length);
							this.imageSrc = 'data:image/' + fileType + ';base64,' + res.data.obj.dzqz
								.cwtzFileBase64Str;
						} else {
							this.imageSrc = '';
						}
						var fptzFileName = res.data.obj.dzqz.fptzFileName;
						if (this.notemptyandnull(fptzFileName)) {
							var fptzFileType = fptzFileName.substring(fptzFileName.lastIndexOf('.') + 1,
								fptzFileName.length);
							this.fptzImgSrc = 'data:image/' + fptzFileType + ';base64,' + res.data.obj.dzqz
								.fptzFileBase64Str;
						} else {
							this.fptzImgSrc = '';
						}
						this.dzqzFrom.zhengshuFile = res.data.obj.dzqz.zhengshu;
						this.dzqzFrom.cwtzFile = res.data.obj.dzqz.cwtz;
						this.dzqzFrom.fptzFile = res.data.obj.dzqz.fptz;
						this.dzqzFrom.zsdqrq = res.data.obj.dzqz.zsdqrq;
						this.dzqzFrom.zsmm = res.data.obj.dzqz.zsmm;
						console.log(this.dzqzFrom);
						if (res.data.obj.invoiceFormat) {
							if (res.data.obj.invoiceFormat.downloadContainsPagesType) {
								this.invoiceFormatForm.id = res.data.obj.invoiceFormat.id;
								this.invoiceFormatForm.version = res.data.obj.invoiceFormat.version;
							}
							if (res.data.obj.invoiceFormat.downloadContainsPagesType) {
								this.invoiceFormatForm.downloadContainsPagesType = JSON.parse(res.data.obj
									.invoiceFormat.downloadContainsPagesType);
							}
							if (res.data.obj.invoiceFormat.sendContainsPagesType) {
								this.invoiceFormatForm.sendContainsPagesType = JSON.parse(res.data.obj
									.invoiceFormat.sendContainsPagesType);
							}
							if (res.data.obj.invoiceFormat.downloadContainsPagesName) {
								this.invoiceFormatForm.downloadContainsPagesName = res.data.obj.invoiceFormat
									.downloadContainsPagesName;
							}
							if (res.data.obj.invoiceFormat.sendContainsPagesName) {
								this.invoiceFormatForm.sendContainsPagesName = res.data.obj.invoiceFormat
									.sendContainsPagesName;
							}
						}
					}
					this.jbxxdiag = true;
					this.$nextTick(() => {
						this.$refs.Lejiref.ZHiZujian(this.isOpenType);
						this.$refs.Lejiref.Chushua();
					});
				});
			},
			blobToDataURI(blob, callback) {
				var reader = new FileReader();
				reader.readAsDataURL(blob);
				reader.onload = function(e) {
					callback(e.target.result);
				};
			},
			dataURItoBlob(base64Data) {
				let byteString;
				if (base64Data.split(',')[0].indexOf('base64') >= 0) byteString = atob(base64Data.split(',')[1]);
				//base64 解码
				else {
					byteString = unescape(base64Data.split(',')[1]);
				}
				let mimeString = base64Data
					.split(',')[0]
					.split(':')[1]
					.split(';')[0]; //mime类型 -- image/png

				// var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
				// var ia = new Uint8Array(arrayBuffer);//创建视图
				let ia = new Uint8Array(byteString.length); //创建视图
				for (let i = 0; i < byteString.length; i++) {
					ia[i] = byteString.charCodeAt(i);
				}
				let blob = new Blob([ia], {
					type: mimeString
				});
				return blob;
			},
			changeOpen() {
				this.radiochange = '';

				Object.keys(this.jibenform).map(key => (this.jibenform[key] = ''));
				Object.keys(this.xxiangform).map(key => (this.xxiangform[key] = ''));
				Object.keys(this.dzqzFrom).map(key => (this.dzqzFrom[key] = ''));
				Object.keys(this.fileName).map(key => (this.fileName[key] = ''));
				this.invoiceFormatForm = {
					downloadContainsPagesType: ['0'],
					sendContainsPagesType: ['0'],
					downloadContainsPagesName: '0',
					sendContainsPagesName: '0'
				};
				this.cwtz = '';
				this.zhengshu = '';
				this.kaipiaoform0 = JSON.parse(JSON.stringify(this.defkaipiaoform));
				this.kaipiaoform1 = JSON.parse(JSON.stringify(this.defkaipiaoform));
				this.kaipiaoform2 = JSON.parse(JSON.stringify(this.defkaipiaoform));
				this.kaipiaoform3 = JSON.parse(JSON.stringify(this.defkaipiaoform));
				this.kpjFrom.piaojilist = [];
				Object.keys(this.kaipiaoformData).map(key => (this.kaipiaoformData[key] = ''));

				if (this.$refs['jibenform']) {
					this.$nextTick(() => {
						this.$refs['jibenform'].clearValidate();
					});
				}
				if (this.$refs['kaipjform']) {
					this.$nextTick(() => {
						this.$refs['kaipjform'].clearValidate();
					});
				}
				if (this.$refs['kaipform0']) {
					this.$nextTick(() => {
						this.$refs['kaipform0'].clearValidate();
					});
				}
				if (this.$refs['kaipform1']) {
					this.$nextTick(() => {
						this.$refs['kaipform1'].clearValidate();
					});
				}
				if (this.$refs['kaipform2']) {
					this.$nextTick(() => {
						this.$refs['kaipform2'].clearValidate();
					});
				}
				if (this.$refs['kaipform3']) {
					this.$nextTick(() => {
						this.$refs['kaipform3'].clearValidate();
					});
				}
				this.jibenform = {};
				this.chooseheadindex = 0;
			},
			initShengf() {
				this.$https.fetchPost('config/getSelectByKey', 'OFD_SEAL_NO').then(res => {
					this.selectShengf = this.setSelectKey(JSON.parse(res.data.obj));
				});
			},
			isFormValidate(type) {
				let isValidate = 0;
				//基本信息
				if (this.$refs['jibenform']) {
					this.$refs['jibenform'].validate(valid => {
						if (!valid) {
							isValidate = 1;
						}
					});
				}
				if (this.$refs['kaipjform']) {
					this.$refs['kaipjform'].validate(valid => {
						if (!valid) {
							isValidate = 4;
						}
					});
				}
				if (this.$refs['kaipform0']) {
					this.$refs['kaipform0'].validate(valid => {
						if (!valid) {
							isValidate = 3;
						}
					});
				}
				if (this.$refs['kaipform1']) {
					this.$refs['kaipform1'].validate(valid => {
						if (!valid) {
							isValidate = 3;
						}
					});
				}

				if (this.$refs['kaipform2']) {
					this.$refs['kaipform2'].validate(valid => {
						if (!valid) {
							isValidate = 3;
						}
					});
				}
				if (this.$refs['kaipform3']) {
					this.$refs['kaipform3'].validate(valid => {
						if (!valid) {
							isValidate = 3;
						}
					});
				}

				if (isValidate == 1) {
					if (type == 2) {
						this.$message.error('请先完善基本信息填写');
					} else {
						this.$message.error('基本信息页面信息未填写完整');
					}
					return false;
				} else if (isValidate == 2 && this.isOpenType == 2) {
					this.$message.error('开票机验证不通过。');
					return false;
				} else if (isValidate == 3 && this.isOpenType == 2) {
					this.$message.error('开票规则验证不通过。');
					return false;
				} else if (isValidate == 4 && this.isOpenType == 2) {
					this.$message.error('开票机设置验证不通过。');
					return false;
				}
				return true;
			},
			invalidSerchForm(type) {
				switch (type) {
					/*	case "qiybh":
                  this.jibenform.code = this.jibenform.fapdm.replace(/[^\d]/g, '');
                  break;*/
					case 'qiybh':
						this.jibenform.qiybh = this.jibenform.qiybh.replace(/[^\da-zA-Z][?\-]/g, '');
						break;
					case 'taxNumber':
						this.jibenform.taxNumber = this.jibenform.taxNumber.replace(/[^\da-zA-Z]/g, '');
						break;
				}
				this.jibenform.code = this.jibenform.taxNumber + '' + this.jibenform.qiybh;
				this.jibenform.code = this.jibenform.code.replace('undefined', '');
			},
			uploadFile($event, type) {
				console.log($event);
				let upfilename = $event.target.files[0].name;
				console.log(upfilename);
				let fileData = $event.target.files[0];
				let fileType;
				if (upfilename) {
					fileType = upfilename.substring(upfilename.lastIndexOf('.') + 1, upfilename.length).toLowerCase();
				}
				console.log(fileType);
				if (type == 'zhengshu') {
					if (fileType != 'p12' && fileType != 'pfx') {
						this.$message.error('证书类型不匹配。');
						return;
					}
					this.dzqzFrom.zhengshuFile = fileData;
					this.fileName.zhengshuName = upfilename;
				} else if (type == 'cwtz') {
					if (fileType != 'png' && fileType != 'gif') {
						this.$message.error('只能上传gif和png类型图片。');
						return;
					}
					this.dzqzFrom.cwtzFile = fileData;
					this.fileName.cwtzName = upfilename;

					this.getBase64(fileData).then(res => {
						this.imageSrc = res;
					});
				} else if (type == 'fptz') {
					if (fileType != 'png' && fileType != 'gif') {
						this.$message.error('只能上传gif和png类型图片。');
						return;
					}
					this.dzqzFrom.fptzFile = fileData;
					this.fileName.fptzName = upfilename;

					this.getBase64(fileData).then(res => {
						this.fptzImgSrc = res;
					});
				}
				console.log(this.dzqzFrom);
				console.log(this.fileName);
			},

			/**
			 * @param file
			 * @return base64
			 * */
			getBase64(file) {
				return new Promise((resolve, reject) => {
					let reader = new FileReader();
					let fileResult = '';
					reader.readAsDataURL(file);
					//开始转
					reader.onload = function() {
						fileResult = reader.result;
					};
					//转 失败
					reader.onerror = function(error) {
						reject(error);
					};
					//转 结束  咱就 resolve 出去
					reader.onloadend = function() {
						resolve(fileResult);
					};
				});
			},
			inputinput(e) {
				if (e.prop == 'kaipjbh') {
					if (!/^[0123456789]+$/.test(e.value)) {
						this.kpjform.kaipjbh = this.kpjform.kaipjbh.substring(0, this.kpjform.kaipjbh.length - 1);
					}
				}
				if (e.prop == 'mainNo') {
					if (!/^[0123456789]+$/.test(e.value)) {
						this.kpjform.mainNo = this.kpjform.kaipjbh.substring(0, this.kpjform.mainNo.length - 1);
					}
				}
				console.log(e);
			},
			savekpj() {
				this.$refs.taxform.submitForm();
			},
			getdata(row) {
				let paramstr = JSON.stringify(row);
				let param = JSON.parse(paramstr);
				if (param.allowFplx != null && param.allowFplx != '') {
					param.allowFplx = param.allowFplx.join(',');
					if (param.allowFplx.indexOf(',') == 0) {
						param.allowFplx = param.allowFplx.substr(1);
					}
				} else {
					param.allowFplx = '';
				}
				console.log(param);
				//编辑
				if (row.id != '' && row.id != undefined) {
					this.$https.fetchPost('sys/admin/updateKaipj', param).then(res => {
						if (res.data.success) {
							this.$message.success('修改成功');
							this.getkpjList();
						}
					});
				} else {
					console.log(this.checkedRow.code);
					param.qiybh = this.checkedRow.code;
					if (this.isAddCompany) {
						this.$confirm('保存税盘信息后，基本信息中“企业税号”和“企业编号”将无法修改，是否继续?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							})
							.then(() => {
								this.saveCompanyAndKpj(param);
							})
							.catch(() => {
								this.$message({
									type: 'info',
									message: '已取消'
								});
							});
					} else {
						this.$https.fetchPost('sys/admin/saveKaipj', param).then(res => {
							if (res.data.success) {
								this.$message.success('新增成功');
								this.getkpjList();
							}
						});
					}
				}
			},
			/*查询开票机*/
			getkpjList() {
				this.isaddkpj = false;
				if (this.checkedRow.code) {
					this.$https.fetchPost('doc/getKaipjListByQiybh', this.checkedRow.code).then(res => {
						if (res.data.success) {
							this.kpjdata = JSON.parse(res.data.obj);
						}
					});
				}
			},
			addkpj() {
				if (!this.isFormValidate(2)) {
					this.chooseheadindex = 0;
					return;
				}
				Object.keys(this.kpjform).map(key => (this.kpjform[key] = ''));
				this.kpjform.allowFplx = [];
				this.kpjform.queskpj = '0';
				this.kpjform.management = '1';
				this.kpjform.tunnelName = '3';
				// this.initKpjType(this.kpjform.management);
				this.kpjform.qiybh = this.checkedRow.code;
				this.isaddkpj = true;
				this.kpjform = JSON.parse(JSON.stringify(this.kpjform));
				if (this.$refs.taxform) {
					this.$nextTick(() => {
						this.$refs.taxform.clearValidate();
					});
				}
			},
			updatekpj(row) {
				let faplxstr = row.allowFplx;
				let str = JSON.stringify(row);
				let rowData1 = JSON.parse(str);
				for (let key in this.kpjform) {
					if (!rowData1.hasOwnProperty(key)) {
						rowData1[key] = '';
					}
				}
				this.kpjform = rowData1;
				let faplxlist = [];
				if (faplxstr != null && faplxstr != '') {
					faplxlist = faplxstr.split(',');
				}
				this.kpjform.allowFplx = faplxlist;
				// this.initKpjType(this.kpjform.management);
				this.kpjform.qiybh = this.checkedRow.code;
				console.log('faplxstr:' + JSON.stringify(this.kpjform));
				this.isaddkpj = true;
				this.$nextTick(() => {
					this.$refs.taxform.clearValidate();
				});
				this.kpjform = JSON.parse(JSON.stringify(this.kpjform));
				if (this.$refs.taxform) {
					this.$nextTick(() => {
						this.$refs.taxform.clearValidate();
					});
				}
			},
			deletekpj(row) {
				this.$confirm('是否删除?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.$https.fetchPost('sys/admin/delKaipj', row.id).then(res => {
							if (res.data.success) {
								this.$message.success('删除成功');
								this.getkpjList();
							} else {
								this.$message.success('删除失败');
							}
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			},
			//修改事件
			radiochange1(e) {
				if (e.prop == 'management') {
					this.initKpjType(e.value);
					this.kpjform.tunnelName = '';
					this.$refs['taxform'].clearValidate();
				}
			},
			initKpjType(val) {
				this.formlist.forEach(item => {
					if (item.prop == 'tunnelName') {
						if (val == 0) {
							item.selectval = [{
									label: '云小开助手',
									value: '1'
								},
								{
									label: '组件',
									value: '2'
								}
							];
						} else if (val == 1) {
							item.selectval = [{
								label: 'XMB',
								value: '3'
							}];
						}
					}
				});
			},
			//先添加企业信息，拿到企业编号，再添加税盘信息
			saveCompanyAndKpj(param) {
				let jibenformparams = JSON.parse(JSON.stringify(this.jibenform));
				jibenformparams.groupId = this.useropj.companyGroupId;
				let formData = new FormData();
				formData.append('company', JSON.stringify(jibenformparams));
				//开票信息
				this.xxiangform.shengf = jibenformparams.shengf;
				this.xxiangform = JSON.parse(JSON.stringify(this.xxiangform));
				let xxiangformparams = this.xxiangform;
				xxiangformparams.qiybh = jibenformparams.code;
				xxiangformparams.nasrsbh = jibenformparams.taxNumber;
				xxiangformparams.nasrmc = jibenformparams.name;
				delete xxiangformparams.updateTime;
				delete xxiangformparams.createTime;
				formData.append('stxx', JSON.stringify(xxiangformparams));
				this.kaipiaoform0.faplx = '026';
				this.kaipiaoform0.qiybh = jibenformparams.code;
				this.kaipiaoform0.nasrsbh = jibenformparams.taxNumber;
				this.kaipiaoform0.nasrmc = jibenformparams.name;
				this.kaipiaoform1.faplx = '028';
				this.kaipiaoform1.qiybh = jibenformparams.code;
				this.kaipiaoform1.nasrsbh = jibenformparams.taxNumber;
				this.kaipiaoform1.nasrmc = jibenformparams.name;
				this.kaipiaoform2.faplx = '004';
				this.kaipiaoform2.qiybh = jibenformparams.code;
				this.kaipiaoform2.nasrsbh = jibenformparams.taxNumber;
				this.kaipiaoform2.nasrmc = jibenformparams.name;
				this.kaipiaoform3.faplx = '007';
				this.kaipiaoform3.qiybh = jibenformparams.code;
				this.kaipiaoform3.nasrsbh = jibenformparams.taxNumber;
				this.kaipiaoform3.nasrmc = jibenformparams.name;
				formData.append('stxxFplxhd0', JSON.stringify(this.kaipiaoform0));
				formData.append('stxxFplxhd1', JSON.stringify(this.kaipiaoform1));
				formData.append('stxxFplxhd2', JSON.stringify(this.kaipiaoform2));
				formData.append('stxxFplxhd3', JSON.stringify(this.kaipiaoform3));
				var dzqz = {};
				dzqz.qiybh = this.checkedRow.code;
				dzqz.zsdqrq = this.dzqzFrom.zsdqrq;
				dzqz.zsmm = this.dzqzFrom.zsmm;
				formData.append('dzqz', JSON.stringify(dzqz));
				formData.append('zhengshu', this.dzqzFrom.zhengshuFile);
				formData.append('cwtz', this.dzqzFrom.cwtzFile);
				this.$https.fetchPost('sys/admin/saveStxxPojo', formData).then(res => {
					if (res.data.success) {
						this.isAddCompany = false;
						this.isOpenType = 2;
						this.checkedRow = res.data.obj;
						param.qiybh = this.checkedRow.code;
						this.$https.fetchPost('sys/admin/saveKaipj', param).then(rr => {
							if (rr.data.success) {
								this.$message.success('新增成功');
								this.getkpjList();
								this.getCompanyList(this.useropj.companyGroupId);
							}
						});
					}
				});
			},
			kpjdetails(row) {
				this.options = [];
				this.faplxdm = '';
				this.oneKpxe = '';
				this.sksbbh = row.kaipjbh;
				this.qiybh = row.qiybh;

				let params = {
					qiybh: row.qiybh,
					kpjbh: row.kaipjbh
				};
				this.$https.fetchPost('/kpjdetails/getList', JSON.stringify(params)).then(
					res => {
						if (res.data.success) {
							console.log(res.data);
							this.kpjDetailsList = res.data.obj;
							// this.selectFplxdmChange(this.faplxdm)
							if (this.kpjDetailsList.length > 0) {
								this.getSelectResult(null);
							} else {
								Object.keys(this.formdata).map(key => (this.formdata[key] = ''));
								if (row.allowFplx != null && row.allowFplx != '') {
									let fplxArr = row.allowFplx.split(',');
									this.options = [];
									fplxArr.forEach(item => {
										this.fplxlist.forEach(str => {
											if (item == str.value) {
												this.options.push(str);
											}
										});
									});
								}
							}
						}
					},
					error => {
						this.$message.error('数据获取失败:' + error);
						Object.keys(this.formdata).map(key => (this.formdata[key] = ''));
						if (row.allowFplx != null && row.allowFplx != '') {
							let fplxArr = row.allowFplx.split(',');
							this.options = [];
							fplxArr.forEach(item => {
								this.fplxlist.forEach(str => {
									if (item == str.value) {
										this.options.push(str);
									}
								});
							});
						}
					}
				);

				this.xqdiag = true;
			},
			getSelectResult(fplxdm) {
				let dms = this.kpjDetailsList.map(item => item.fplxdm);
				this.options = [];
				dms.forEach(item => {
					this.fplxlist.forEach(str => {
						if (item == str.value) {
							this.options.push(str);
						}
					});
				});
				if (this.options.length > 0) {
					if (fplxdm == null || fplxdm == '') {
						this.faplxdm = this.options[0].value;
					}
					this.selectFplxdmChange(this.faplxdm);
				}
			},
			selectFplxdmChange(value) {
				if (this.kpjDetailsList.length > 0) {
					let kpjDetails = this.kpjDetailsList.filter(item => item.fplxdm == value);
					if (kpjDetails.length > 0) {
						Object.keys(this.formdata).map(key => (this.formdata[key] = kpjDetails[0][key]));
						this.oneKpxe = kpjDetails[0].oneKpxe;
					} else {
						Object.keys(this.formdata).map(key => (this.formdata[key] = ''));
						this.oneKpxe = '';
					}
				} else {
					Object.keys(this.formdata).map(key => (this.formdata[key] = ''));
					this.oneKpxe = '';
				}
			},
			selectChange(value) {
				this.oneKpxe = '';
				Object.keys(this.formdata).map(key => (this.formdata[key] = ''));
				this.faplxdm = value;
				let fplxdms = this.options.map(item => item.value);
				let params = {
					faplxdm: fplxdms.toString(),
					sksbbh: this.sksbbh,
					qiybh: this.qiybh
				};
				this.$https.fetchPost('sys/admin/getControlEquipment', JSON.stringify(params)).then(
					res => {
						if (res.data.success) {
							this.kpjDetailsList = res.data.obj;
							this.getSelectResult(null);
						}
					},
					error => {
						if (error.code === 'ECONNABORTED' || error.message === 'Network Error' || error.message
							.includes('timeout')) {
							this.$message.error('当前税盘不在线，请确认是否正常连接。');
						}
					}
				);
			}
		}
	};
</script>

<style scoped="scoped" lang="less">
	.nolabelradio /deep/ .el-radio__inner {
		width: 22px;
		height: 22px;
	}

	/deep/ .el-radio {
		margin-right: 10px;
	}

	/deep/ .el-radio__label {
		font-size: 11px;
		color: #999999;
	}

	.kuang {
		padding-left: 14px;
		padding-top: 10px;
		padding-bottom: 19px;
		margin-top: 16px;
		padding-right: 22px;
		background: #ffffff;
		border: 1px solid #f2f2f2;
		opacity: 1;
		border-radius: 2px;
	}

	.forkuozhan {
		font-size: 17px;
		font-weight: 400;
		color: #0080ff;
		margin-bottom: 20px;
	}

	.choosediv:extend(.Verticalcenter-line) {
		// font-size: 20px;
		// color: #0080ff;
		cursor: pointer;
		margin-left: 40px;
		font-size: 14px;
		font-weight: 400;
		color: #666666;
	}

	.choosedivmain:extend(.Verticalcenter-line) {
		font-size: 17px;
		color: #0080ff;
		cursor: pointer;
	}

	.choosedivmain:nth-of-type(2) {
		margin-left: 25px;
	}

	.choosedivmain:nth-of-type(3) {
		margin-left: 25px;
	}

	.choosedivmain:nth-of-type(4) {
		margin-left: 25px;
	}

	.lineall {
		width: 39px;
		height: 3px;
		border-radius: 2px;
		margin-top: 11px;
	}

	// /deep/ .el-dialog__body {
	// 	padding: 0;
	// }

	/deep/ .el-table--small td {
		padding: 4px 0;
	}

	/deep/ .el-table__body-wrapper {
		//min-height: 160px;
	}

	.areatable {
		margin-top: 27px;
	}

	.areacontent {
		margin-left: 21px;
	}

	.sendinput {
		visibility: hidden;
	}

	.bt1 {
		width: 80px;
		height: 31px;
		border: 1px solid #e5e5e5;
		border-radius: 3px;
		font-size: 14px;
		cursor: pointer;
		font-weight: 500;
		color: #2f66fc;
	}
</style>